
export enum DataType {
    Number = "number",
    String = "string",
    Date = "date",
    DateRange = "date_range",
    Array="array",
    Boolean="boolean"
}

export enum HTTPMethod {
    GET = "GET",
    POST = "POST",
    PATCH = "PATCH",
    DELETE = "DELETE"
}
